import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormGroup, Label, Form, Input, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import Table from './common/Table';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const SellerserviceApprove = () => {
    const location = useLocation();
    let navigate = useNavigate();
    
    const [servicesData, setServicesData] = useState([]);
    const [pincodeModal, setPincodeModal] = useState(false);
    const [pincodes, setPincodes] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const [page, setPage] = useState(1);

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
            alert("Access Denied");
            navigate("/");
            return;
        } else {
            setUserRights(rights);
            getServices();
        }
    };

    const getServices = async (limit = 10, offset = 0, search = {}, loader = true, reset = false) => {
        if (reset) {
            setPage(1);
            offset = 0;
        } else {
            setPage(offset / limit + 1);
        }
        const data = {
            action: "read",
            source: "admin",
            user_type: "seller",
            type: location.state.rowType=="service"?"normal":"logistics",
            'seller_id': location.state?.sellerId || localStorage.getItem('sellerId'),
            'start_date': location.state.startDate.length > 0 ? location.state.startDate : $('#Date-from').val(),
            'end_date': location.state.endDate.length > 0 ? location.state.endDate : $('#Date-to').val(),
            'limit': limit,
            'offset': offset
        };
        let response = await common.apiRequest('post', '/admin/get-sellers-service-data', data, loader);
        if (response.status === 200) {
            if (response.data.code === 'success') {
                setServicesData(response.data.data);
                setTotalRecords(response.data.totalRecords);
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    };

    const togglePincodeModal = () => {
        setPincodeModal(!pincodeModal);
    }

    const viewPincodes = async (serviceId) => {
        let data = {
            'service_id': serviceId,
            'source': 'admin'
        }
        let response = await common.apiRequest('post', '/seller/get-pincodes', data);
        if (response.data.code === 'success') {
            togglePincodeModal();
            setPincodes(response.data.data);
        } else {
            common.alert(response.data.error, 'error');
        }
    }

    const deleteService = async (ID,serviceId) => {
        var parameters = {
            'id':  ID,
            "service_id": serviceId,
            'action': 'delete',
            'source': 'admin'
        };
        let response = await common.apiRequest('post', '/seller/crud-seller-services', parameters);
        if (response.status == 200) {
            if (response.data.code == "success") {
                alert(response.data.message);
            } else {
                alert(response.data.error, 'error');
            }
        }
        getServices(10, (page - 1) * 10, {}, true, false)
    }

    const approveProduct = async (product_id) => {
        let data = {
            'id': product_id,
            "active": 1,
            "action": "update",
            "source":"admin"
        };
        let response = await common.apiRequest('post', '/seller/crud-seller-services', data);
        if (response.data.code === 'success') {
            setServicesData(prevData => 
                prevData.map(service => 
                    service.id === product_id ? { ...service, active: 1 } : service
                )
            );
            alert(response.data.message);
        } else {
            alert(response.data.error);
        }
    };
// Replace your existing HotProductDropdown component with this reactive version:

const HotProductDropdown = ({ data }) => {
    const serviceData = data; // This contains the full service object
    const id = serviceData.id;
    
    // Use the actual current value from the data, not local state
    const currentValue = serviceData.is_hot_service == 1 ? "Yes" : "No";
    
    const handleChange = async (e) => {
        const value = e.target.value;
        
        try {
            await setUnsetHotProduct(id, value);
        } catch (error) {
            console.error('Failed to update hot service status:', error);
            // Optionally show error message to user
            alert('Failed to update hot service status');
        }
    };

    return (
        <select
            className="form-select form-select-sm"
            onChange={handleChange}
            value={currentValue}
        >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </select>
    );
};

const setUnsetHotProduct = async (id, value) => {
    let requestData = {
        'id': id,
        'value': value,
        'source': "service"
    }
    
    let response = await common.apiRequest('post', '/admin/set-unset-hot-product', requestData);
    
    if (response.data.code == 'success') {
        alert(response.data.message);
        
        setServicesData(prevData => 
            prevData.map(service => 
                service.id === id ? { 
                    ...service, 
                    is_hot_service: value === 'Yes' ? 1 : 0 
                } : service
            )
        );
    } else {
        alert(response.data.error);
        throw new Error('API call failed');
    }
}
    const serviceColumns = [
  { accessor: "service_name", header: "Service Name", },
  { accessor: "parent_category.category_name", header: "Parent Category",
    render: row => row.parent_category.category_name
   },
  { accessor: "sub_category.category_name", header: "Sub Category",
    render: row => row.sub_category.category_name
   },
  { accessor: "created_at", header: "Service Date" },
  { accessor: "service_type", header: "Service Type" },
  {
    accessor: "service_image",
    header: "Service Media",
    render: (row) => {
        const media = row.service_image;
        if (!media) return "";
        
        // Helper function to check if file is video
        const isVideo = (filename) => {
            const videoExtensions = ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.wmv', '.flv', '.m4v'];
            return videoExtensions.some(ext => filename.toLowerCase().includes(ext));
        };
        
        // Helper function to check if file is image
        const isImage = (filename) => {
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'];
            return imageExtensions.some(ext => filename.toLowerCase().includes(ext)) || filename.includes('blob');
        };
        
        return (
            <div className="d-flex justify-content-center mb-3 flex-wrap gap-2">
                {media.split(",").map((file, index) => {
                    const trimmedFile = file.trim();
                    const fullUrl = `${envConfig.api_url}${trimmedFile}`;
                    
                    if (isVideo(trimmedFile)) {
                        return (
                            <div key={index} className="media-item">
                                <video
                                    width="100"
                                    height="100"
                                    className="rounded-2"
                                    controls
                                    preload="metadata"
                                    style={{ objectFit: 'cover' }}
                                >
                                    <source src={fullUrl} type="video/mp4" />
                                    <source src={fullUrl} type="video/webm" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        );
                    } else if (isImage(trimmedFile)) {
                        return (
                            <div key={index} className="media-item">
                                <Zoom zoomImg={false}>
                                    <img
                                        width="100"
                                        height="100"
                                        className="rounded-2"
                                        src={fullUrl}
                                        alt={`Service ${index + 1}`}
                                        style={{ objectFit: 'cover' }}
                                    />
                                </Zoom>
                            </div>
                        );
                    } else {
                        // Fallback for unknown file types
                        return (
                            <div key={index} className="media-item">
                                <div 
                                    className="d-flex align-items-center justify-content-center rounded-2 bg-light"
                                    style={{ width: '100px', height: '100px', fontSize: '12px' }}
                                >
                                    File
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
        );
    },
},
  { accessor: "service_description", header: "Service Description" },
  { accessor: "price", header: "Service Price" },
  { accessor: "service_sku", header: "Service SKU" },
  { accessor: "service_by", header: "Service By" },
  { accessor: "gst_rate", header: "GST Rate" },
  { accessor: "taxable_value", header: "Taxable Value" },
  { accessor: "terms_of_parts_no_extra_cost", header: "Terms of Parts" },
  { accessor: "legal_disclaimer", header: "Legal Disclaimer" },
  { accessor: "warranty_or_gurantee", header: "Warranty or Guarantee" },
  { accessor: "use_utility_of_services", header: "Use Utility of Services" },
  { accessor: "after_sale_service", header: "After Sale Service" },
  { accessor: "inclustion_exclusion", header: "Inclusion/Exclusion" },
  { accessor: "parts_rate_list", header: "Parts Rate List" },
  { accessor: "faq", header: "FAQ" },

  ...(location.state.rowType === "logistics"
    ? [
        { accessor: "logistics_delivery_type", header: "Logistics Delivery Type" },
        { accessor: "range_in_grams_from", header: "Range In Grams From" },
        { accessor: "range_in_grams_to", header: "Range In Grams To" },
        { accessor: "zone_a", header: "Zone A" },
        { accessor: "zone_b", header: "Zone B" },
        { accessor: "zone_c", header: "Zone C" },
        { accessor: "zone_d", header: "Zone D" },
        { accessor: "zone_e", header: "Zone E" },
        { accessor: "zone_f", header: "Zone F" },
        { accessor: "min_delivery_time", header: "Minimum Delivery Time" },
        { accessor: "max_delivery_time", header: "Maximum Delivery Time" },
        { accessor: "additional_grams", header: "Additional Grams" },
        {
          accessor: "additional_price_add_in_every_zone",
          header: "Additional Price Add In Every Zone",
        },
      ]
    : []),

  {
    header: "Pincodes",
    render: (row) => (
      <button className="btn btn-info btn-sm" onClick={() => viewPincodes(row.id)}>
        View Pincodes
      </button>
    ),
  },
  {
    header: "Actions",
    render: (row) =>
      row.active ? (
        "Approved"
      ) : (
        userRights.edit &&
        <Button color="success" size="sm" onClick={() => approveProduct(row.id)}>
          Approve Service
        </Button>
      ),
  },
  {
    header: "Delete Products",
    render: (row) => {
      const id = row.id;
      const productId = row.seller_service_pincodes?.[0]?.service_id;
      return (
        userRights.delete &&
        <button
          className="btn btn-danger btn-sm ml-2"
          onClick={() => deleteService(id, productId)}
        >
          Delete
        </button>
      );
    },
  },
  {
    accessor: "is_hot_service",
    header: "Hot service",
    render: (row) =>    userRights.edit && <HotProductDropdown data={row} />,
  },
];

    
    const exportData = servicesData.map((service) => ({
        "Service Name": service.service_name,
        "Parent Category": service.parent_category?.category_name || '',
        "Sub Category": service.sub_category?.category_name || '',
        "Service Date": service.created_at,
        "Service Type": service.service_type,
        "Service Description": service.service_description,
        "Service Price": service.price,
        "Service SKU": service.service_sku,
        "Service By": service.service_by,
        "GST Rate": service.gst_rate,
        "Taxable Value": service.taxable_value,
        "Terms of Parts": service.terms_of_parts_no_extra_cost,
        "Legal Disclaimer": service.legal_disclaimer,
        "Warranty or Guarantee": service.warranty_or_gurantee,
        "Use Utility of Services": service.use_utility_of_services,
        "After Sale Service": service.after_sale_service,
        "Inclusion/Exclusion": service.inclustion_exclusion,
        "Parts Rate List": service.parts_rate_list,
        "FAQ": service.faq,
        ...(location.state.rowType === 'logistics' ? {
            "Logistics Delivery Type": service.logistics_delivery_type,
            "Range In Grams From": service.range_in_grams_from,
            "Range In Grams To": service.range_in_grams_to,
            "Zone A": service.zone_a,
            "Zone B": service.zone_b,
            "Zone C": service.zone_c,
            "Zone D": service.zone_d,
            "Zone E": service.zone_e,
            "Zone F": service.zone_f,
            "Minimum Delivery Time": service.min_delivery_time,
            "Maximum Delivery Time": service.max_delivery_time,
            "Additional Grams": service.additional_grams,
            "Additional Price Add In Every Zone": service.additional_price_add_in_every_zone,
        } : {})
    }));

    const handleExportCSV = () => {
        exportToCSV(exportData, location.state.rowType === 'logistics' ? 'Logistics Services' : 'Normal Services');
    }

    const handleExportExcel = () => {
        exportToExcel(exportData, location.state.rowType === 'logistics' ? 'Logistics Services' : 'Normal Services');
    }

    const handleExportPDF = () => {
        exportToPDF(exportData, location.state.rowType === 'logistics' ? 'Logistics Services' : 'Normal Services');
    }

    return (
        <>
            <h1>{location.state.rowType === 'logistics' ? 'Logistics Services' : 'Normal Services'}</h1>
            <Form className='row'>
                <FormGroup className='col-md-4 row'>
                    <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                    <Input 
                        type='date' 
                        defaultValue={location.state.startDate.length > 0 ? location.state.startDate :moment().startOf('month').format('YYYY-MM-DD')} 
                        onChange={() => getServices()} 
                        className="form-control col-md-5" 
                        id="Date-from" 
                        name="Date-from"
                    />
                </FormGroup>
                <FormGroup className='col-md-4 row'>
                    <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                    <Input 
                        type='date' 
                        defaultValue={location.state.endDate.length > 0 ? location.state.endDate : moment().endOf('month').format('YYYY-MM-DD')} 
                        onChange={() => getServices()} 
                        className="form-control col-md-5" 
                        id="Date-to" 
                        name="Date-to"
                    />
                </FormGroup>
            </Form>
            
            <div>
                <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
            </div>
            
            <div className="mt-4">
                <div className="ag-theme-quartz" style={{ height: 500 }}>
                    <Table
                        columns={serviceColumns}
                        data={servicesData}
                        totalRecords={totalRecords}
                        pageSize={10}
                        currentPage={page}
                        onPageChange = {(limit, offset, search, reset) =>{
                            getServices(limit, offset, search, 0, true, reset);
                        }}
                    />
                </div>
            </div>

            <Modal isOpen={pincodeModal} toggle={togglePincodeModal} size="md">
                <ModalHeader toggle={togglePincodeModal}>Pincodes List</ModalHeader>
                <ModalBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                        {pincodes.map((pincode) => (
                            <div key={pincode.pincode} style={{ marginBottom: '10px' }}>
                                {pincode.pincode}
                            </div>
                        ))}
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}

export default SellerserviceApprove;